import React, { useEffect, useState } from 'react';
import { Colors } from 'library';
import { Row, Stack, Text, Title } from 'library/ui';
import { styled, keyframes } from '@mui/material';
import TandemBlocksLogo from 'assets/images/tandem-blocks-logo.svg';

const messages = [
    'Finding teachers near you…',
    'Checking credentials & background checks…',
    'Looking for the best fit…',
    'Almost there…',
];

export default function FindingTeachersLoader({ zipCode }: { zipCode: string }) {
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % messages.length);
        }, 2400);
        return () => clearInterval(interval);
    }, []);

    return (
        <Stack padding="lg" align="center" gap="lg" fullWidth>
            <LogoBounce>
                <TandemBlocksLogo htmlColor={Colors.darkNavy} style={{ height: 64, width: 64 }} />
            </LogoBounce>
            <Stack align="center" gap="sm">
                <Title size="h1">{messages[messageIndex]}</Title>
                <Text tone="secondary" align="center">
                    Searching near {zipCode}
                </Text>
            </Stack>
            <Row gap="sm">
                <Dot delay={0} />
                <Dot delay={0.2} />
                <Dot delay={0.4} />
            </Row>
        </Stack>
    );
}

const bounce = keyframes`
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-16px); }
`;

const pulse = keyframes`
    0%, 100% { opacity: 0.3; transform: scale(0.8); }
    50% { opacity: 1; transform: scale(1); }
`;

const LogoBounce = styled('div')({
    animation: `${bounce} 1.4s ease-in-out infinite`,
});

const Dot = styled('div')<{ delay: number }>(({ delay }) => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: Colors.secondary,
    animation: `${pulse} 1.4s ease-in-out infinite`,
    animationDelay: `${delay}s`,
}));
